module.exports = __webpack_public_path__ + "img/2-4.c55ff283.png";